// extracted by mini-css-extract-plugin
export default {"container":"MatchEvents_container__MCRbc","name":"MatchEvents_name__ajB9f","time":"MatchEvents_time__RJ-XI"};